import { client } from 'api/client';
import { URL } from 'api/urls';

import { TCmModuleVendorsDTO } from '@interfaces/cmModule/cmModule';

const { cmModuleVendors } = URL;

export const getCmModuleAvailableVendors = (): Promise<TCmModuleVendorsDTO> => {
	return client.get(cmModuleVendors);
};

export const setDefaultVendor = ({ vendor }: { vendor: string }): Promise<void> => {
	return client.post(`${cmModuleVendors}/mark-as-favourite`, { vendor });
};

export const unsetDefaultVendor = ({ vendor }: { vendor: string }): Promise<void> => {
	return client.post(`${cmModuleVendors}/unmark-as-favourite`, { vendor });
};
